import React from "react";
import { Link } from "react-router-dom";

import "./NavLink.css";

export default function NavLink(props){
    return (
        <Link className = "main-nav-link-container" to = {props.route}><li className = "main-nav-link">{props.children}</li></Link>
    );
}